// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"56908292","70":"68b89b37","160":"f4d5f72c","208":"967d5843","293":"7723a92c","453":"71f2a392","516":"7d074851","519":"f12ee976","917":"c77a2c33","946":"b5e57ccb"}[chunkId] + ".chunk.js";
};